export const damInundation = {
  name: `damInundation`,
  sql: `
    SELECT * FROM solano_dam
    WHERE haz_damg IN ('Yes')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: #81ccb4;
      polygon-opacity: 0.71;
      polygon-comp-op: screen;
    }
    #layer::outline {
      line-width: 0;
      line-color: #FFFFFF;
      line-opacity: 0.5;
    }
  `,
  viz: `
    color: opacity(#81CCB4, 0.5)
    strokeWidth: 0
    `
}